import { environment } from "../../environments/environment";
import { ApiConstants } from "./api.constant.model";

export const apiconstants = {
  ENDPOINT: environment.API_HOST,
  API_LOGIN: environment.API_HOST + "auth/login",
  API_2FALOGIN: environment.API_HOST + "auth/2falogin",
  API_2FA_RESEND: environment.API_HOST + "auth/2freauthlogin",
  API_STATUS: environment.API_HOST + "auth/status",
  API_FORGOT_PASSWORD_SEND_OTP: environment.API_HOST + "forgotpassword/sendotp",
  API_FORGOT_PASSWORD_VALIDATE_OTP: environment.API_HOST + "forgotpassword/validateotp",
  API_FORGOT_PASSWORD_UPDATE: environment.API_HOST + "forgotpassword/updatepassword",
  API_FORGOT_PASSWORD_RESEND: environment.API_HOST + "forgotpassword/resendotp",
  API_POST_PROJECT: environment.API_HOST + "addproject",
  API_PUT_PROJECT: environment.API_HOST + "updateproject",
  API_PROJECTS: environment.API_HOST + "project",
  API_USER_PROJECTS: environment.API_HOST + "user/projects",
  API_ALL_ORGANIZATIONS: environment.API_HOST + "organization/getall",
  API_PROJECT_CONTINENT: environment.API_HOST + "projectcontinent",
  API_PROJECT_TYPE: environment.API_HOST + "projecttype",
  API_DEPARTMENTS: environment.API_HOST + "departmentbyprojectid",
  API_ROOMS_BY_DEPARTMENT: environment.API_HOST + "roombydepartmentid",
  API_RXR: environment.API_HOST + "rxr/room",
  API_ROOMBYROOM: environment.API_HOST + "roomxroom",
  API_DRAWINGS: environment.API_HOST + "drawingbyprojectid",
  API_DRAWING: environment.API_HOST + "drawing",
  API_DRAWING_BY_FOLDER_ID: environment.API_HOST + "drawingbyfolderid",
  API_AGENDA_BY_DEPT: environment.API_HOST + "agendabydeptid",
  API_AGENDA: environment.API_HOST + "agenda",
  API_SCHEDULES: environment.API_HOST + "projectschedulebyprojectid",
  API_SCHEDULES_BY_FOLDER_ID: environment.API_HOST + "projectschedulebyfolderid",
  API_SCHEDULE: environment.API_HOST + "schedule",
  API_REUPLOAD_SCHEDULE: environment.API_HOST + "updateschedule",
  API_ACQUISITION: environment.API_HOST + "acquisition",
  API_GET_ALL_CUT_SHEETS: environment.API_HOST + "jsnbyprojectid",
  API_JSN: environment.API_HOST + "jsn",
  API_JSN_WITH_NAME: environment.API_HOST + "jsn/jsnotherchange",
  API_JSN_REPLACE_TARGET: environment.API_HOST + "jsn/replacetargetjsn",
  API_CHECKJSNEXISTINGAPPROVAL: environment.API_HOST + "checkjsnexistingapproval",
  API_GETALLEXISTINGAPPROVALJSN: environment.API_HOST + "getallexistingapprovaljsn",
  API_PRINT_CUTSHEET: environment.API_HOST + "printcutsheet",
  API_GET_JSN_LIST_BY_DEPARTMENT_ID: environment.API_HOST + "jsnlistbydepartmentid",
  API_JSN_LIST_PRINT_CUTSHEET: environment.API_HOST + "jsnlistforprintcutsheet",
  API_GET_AI_ISSUE: environment.API_HOST + "rxrissuesaireportnew",
  API_JSN_LIST: environment.API_HOST + "jsnlist",
  API_PROJECT_JSN_LIST: environment.API_HOST + "projectjsnlist",
  API_PROJECT_FROM_JSN: environment.API_HOST + "jsnimages/jsn/project",
  API_JSN_BY_PROJECT_NAME_TYPE: environment.API_HOST + "jsnimages/project/jsn",
  API_GET_ALL_ACQUISITIONS: environment.API_HOST + "acquisitionbyprojectid",
  API_GET_ALL_ACQUISITIONS_BY_FOLDER_ID:
    environment.API_HOST + "acquisitionbyfolderid",
  API_ACQUISITIONS: environment.API_HOST + "acquisition",
  API_GET_ALL_CHPS360: environment.API_HOST + "application",
  API_ROOMS: environment.API_HOST + "room",
  API_ATTACHMENT: environment.API_HOST + "attachment",
  API_IMAGE_ATTACHMENT: environment.API_HOST + "attachments",
  API_CHANGE_HISTORY: environment.API_HOST + "getchangehistorybyroomid",
  API_GET_SNAPSHOTS: environment.API_HOST + "getsnapshotsbyroomid",
  API_GET_LAYOUTS: environment.API_HOST + "getlayoutsbyroomid",
  API_DELIVERABLE_FOLDERS: environment.API_HOST + "deliverablebyprojectid",
  API_DELIVERABLES: environment.API_HOST + "projectdeliverable",
  API_DELIVERABLEITEM: environment.API_HOST + "projectdeliverableitem",
  API_DELIVERABLE: environment.API_HOST + "projectdeliverable",
  API_GET_REPORTS: environment.API_HOST + "reportbydeptid",
  API_GET_PRINT_CUTSHEET_DOWNLOAD: environment.API_HOST + "printcutsheetdownload",
  API_REPORT: environment.API_HOST + "report",
  API_CONTACTS: environment.API_HOST + "contact",
  API_POST_CLIENT: environment.API_HOST + "client",
  API_PUT_CLIENT: environment.API_HOST + "client",
  API_GET_MANUFACTURER_CONTACT_DETAILS: environment.API_HOST + "primarycontact",
  API_MANUFACTURER: environment.API_HOST + "jsnmanufacturer",
  API_UPDATE_ROOM_NOTE: environment.API_HOST + "updateroomnote",
  API_GET_ALL_MANUFACTURER: environment.API_HOST + "manufacturer",
  API_GET_UTILITY_LIST: environment.API_HOST + "utilities",
  API_GET_MASTER_JSN_LIST: environment.API_HOST + "user/masterjsnlist",
  API_GET_ALL_ACQUISITION_CODES: environment.API_HOST + "acquisitioncode",
  API_GET_JSN_RXR_DETAIL: environment.API_HOST + "rxrbyjsnid",
  API_GET_CONTACTS: "contacts",
  API_SAVE_CONTACT: "contact",
  API_APPOROVAL_REQUESTS: environment.API_HOST + "approvalrequest",
  API_SHARE_REQUEST: environment.API_HOST + "approvalrequest/share",
  API_SESSION_APPOROVAL_REQUEST: environment.API_HOST + "approvalrequest/shared",
  API_APPOROVAL_REQUEST_REPORT: environment.API_HOST + "approvalrequest/report",
  API_FOLDERS: environment.API_HOST + "folders",
  API_RXR_CHANGE_HISTORY: environment.API_HOST + "roomchangehistory",
  API_RXR_CHANGE: environment.API_HOST + "roomchange",
  API_MISC_CONTACTS: environment.API_HOST + "misccontacts",
  API_SAVE_REPORT_TO_FOLDER: environment.API_HOST + "savereporttofolder",
  API_GET_CONTACT_TYPES:
    environment.API_HOST + "optionset/?entity=contact&name=chps_contacttypes",
  API_DELETE_IMAGE: environment.API_HOST + "deletecutsheetimage",
  //
  API_GET_ALL_CONFIG_RECORDS: environment.API_HOST + "getreportconfig",
  API_GET_FILTER_FROM_CONFIG: environment.API_HOST + "getreportfilterbyreportconfig",
  API_GET_EXECUTED_DATA: environment.API_HOST + "getexecuteddata",
  API_GENERATE_REPORT: environment.API_HOST + "generatereport",
  // security module
  API_GET_ALL_USERS: environment.API_HOST + "contact/portaluser",
  API_GET_ALL_SECURITY_ROLES: environment.API_HOST + "securityRoles",
  API_GET_USER_PROJECT_ROLES: environment.API_HOST + "userprojectrolemapping",
  API_CREATE_USER: environment.API_HOST + "user",
  API_UPDATE_USER: environment.API_HOST + "user",
  API_SPECIFIC_SECURITY_ROLE: environment.API_HOST + "securityrole",
  API_PRIVILEGES: environment.API_HOST + "privileges",
  API_ROLE_PRIVILEGDGE: environment.API_HOST + "rolepriviledgemapping",

  //cloud library
  API_GET_DRAWINGS_BY_JSNID: environment.API_HOST + "drawingbyjsnid",
  API_GET_MASTER_CLOUD_JSN_LIST: environment.API_HOST + "cloudlibrary",
  API_POST_CLIB_JSN: environment.API_HOST + "external/cloudlibrary/jsn",
  API_POST_DUP_JSN_CHECK: environment.API_HOST + "external/jsn/duplicatecheck",
  API_CLIB_PROJECT: environment.API_HOST + "project/cloudlibrary",
  API_MILSTD_PROJECT: environment.API_HOST + "project/milstd",
  API_CLIB_JSN: environment.API_HOST + "cloudlibraryjsn",
  API_MULTIPLE_JSN: environment.API_HOST + "multiplejsn",
  API_PROJECT: environment.API_HOST + "project",
  API_USER_PROJECT_APPROVAL: environment.API_HOST + "userprojectapproval",
  API_ROOM: "/rooms",
  API_ROOM_TYPE_DEPARTMENT: environment.API_HOST + "roomtypebydepartmentid",
  API_ROOM_NAME_DEPARTMENT: environment.API_HOST + "roomnamesbydepartmentid",
  API_ROOM_BY_CODE_TYPE_DEPARTMENT:
    environment.API_HOST + "roombycodetypeanddepartment",
  API_GET_INSTALLATION_AREA: environment.API_HOST + "installationarea",
  API_GET_INSTALL_BY: environment.API_HOST + "installedby",
  API_GET_SUBTRADES: environment.API_HOST + "subtrades",
  API_GET_UTILITY_LENGTH: environment.API_HOST + "utilitylength",
  API_GET_ALL_AI_CHECK_ISSUES: environment.API_HOST + "rxrissues",
  API_GET_ISSUE_RESOLUTION_TYPES: environment.API_HOST + "issueresolutiontypes",
  API_PUT_DEALER_INFO: environment.API_HOST + "account",
  API_GET_ALL_DRAIN_SIZE: environment.API_HOST + "drainsize",
  API_JSN_DEPARTMENT: environment.API_HOST + "jsn/department",
};
